import * as BufferLayout from "@solana/buffer-layout";
import { Field } from "./Field";
export class Optional extends Field {
    constructor(field) {
        super(field.span + 1, field.property);
        this.delegate = field;
    }
    static of(field) {
        return new Optional(field);
    }
    decode(b, offset) {
        const flag = BufferLayout.u8().decode(b, offset);
        if (!flag) {
            return undefined;
        }
        return this.delegate.decode(b, (offset || 0) + 1);
    }
}
//# sourceMappingURL=Optional.js.map